import React from 'react';
import AnimatedDot from './AnimatedDot';

export default function TopBar({ 
  status = 'Δεχόμαστε νέες κρατήσεις',
  location = 'Ηρακλείτου 80, Χαλάνδρι',
  phone = '211 800 4132',
  phoneHref = 'tel:+302118004132',
  showLang = true,
}) {
  return (
    <div className="bg-warm-black text-cream px-[6vw] py-[9px] flex justify-between items-center text-tiny gap-3 flex-nowrap">
      <div className="flex gap-6 items-center min-w-0">
        <span className="flex items-center gap-1.5 truncate">
          <AnimatedDot color="green" />
          <span className="min-[400px]:hidden">Νέες κρατήσεις</span>
          <span className="hidden min-[400px]:inline">{status}</span>
        </span>
        <span className="hidden md:flex items-center gap-1.5 opacity-90">
          📍 {location}
        </span>
      </div>
      <div className="flex gap-5 tracking-wider items-center shrink-0 whitespace-nowrap">
        <a href={phoneHref} className="text-cream opacity-70 hover:opacity-100 hover:text-gold-light transition-opacity">
          📞 {phone}
        </a>
        
      </div>
    </div>
  );
}